import './App.css';
import Navbar from './components/_shared/Navbar';
import Footer from './components/_shared/Footer';
import Home from './components/pages/Home';
import Contact from './components/pages/Contact';
import NotFound from './components/pages/NotFound';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import Impressum from './components/pages/Impressum';
import CookieConsentProvider from './components/CookieConsentProvider';
import ScrollToTop from './components/_shared/ScrollToTop';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './i18n';
import { ThemeProvider } from './theme';

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <CookieConsentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="App">
              <header className="App-header">
                <Navbar />
              </header>
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
        </CookieConsentProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
